/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 * <Header siteTitle={data.site.siteMetadata.title} />
 */

import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header"
import ImageFooter from "../components/img_footer"
import imageF from "../images/footer.png"
import HeaderMobile from "./headerMobile"

// Check if claus layout fits
// else get layout for smaller screens

const LayoutMobile = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQueryMobile {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

    return (
      <>
        <div style={{position: 'sticky',
          top: '0px',
          left: '0px',
          height: '200px',
          right: '0px',
          overflow: 'hidden'}}>
          <HeaderMobile StrPart1='Klima' StrPart2='Leaks'/>
        </div>
        <div
          style={{
            margin: `0 0% 0 0%`,
            maxWidth: '100%',
            padding: `0 0% 0% 0%`,
            paddingTop: 0,
            top: '100px',
            bottom: '0px',
            left: '0px',
            right: '0px',
            overflow: 'auto'}}>

          <div style={{margin: `0 15px 0 30px`, padding: `0% 0% 0% 0%`}}>
            <main>{children}</main>
          </div>

          <footer >
            <div style={{color:"white",backgroundImage:"url("+imageF+")",fontSize:14,height:40}}>
              <Link to="/impressum"
                    style={{ color: `white`, fontWeight: 400, textDecoration: 'none', borderBottom: '0px solid white' }}
                    activeStyle={{
                      color: `white`,
                      fontWeight: 400,
                      borderBottom: '2px solid white'
                    }}>Impressum</Link> - © {new Date().getFullYear()} KlimaLeaks. All rights reserved.
            </div>
          </footer>
        </div>
      </>

    )
}

LayoutMobile.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutMobile
